const RECEIVE_POSTS = 'RECEIVE_POSTS';
export { RECEIVE_POSTS}